import { signal } from "@preact/signals-react";

// Main state signals
export const auditTrailData = signal([]);
export const auditStatus = signal("idle");
export const auditError = signal(null);
export const continuationToken = signal(null);
export const hasMore = signal(false);
export const currentDays = signal(null);
export const currentView = signal("topItems");
export const autoLoadEnabled = signal(false);
export const searchTerm = signal("");
export const isSearching = signal(false);
